export function initVariableBg($) {

	$('.variable-bg-block').each(function(n, el) {
		let block = $(el);
		let bg = block.data('bg');
		let hasfeatured = $(el).hasClass("has-featured");
		let hasfeaturedVideo = $(el).hasClass("has-featured-video");

		// default slide playback
		let playback = true;

		// preload images and check when all loaded
		let loaded = 0;

		// If video BG, pause playback, preload and display video
		// Only Vimeo supported
		if (hasfeaturedVideo) {
			const featuredVideo = document.getElementById("featured-video");
			const player = new Vimeo.Player(featuredVideo);

			let videoDuration = 0; 	// video duration
			let currentTime = 0; 	// video playback time
			let delayTime = 0; 		// delay between animation cycles

			let playbtn = document.getElementById("play-btn-wrapper");

			// hide overlays until video ready
			let btns = document.getElementById("feature-buttons");
			let overlay = document.querySelector(".featured_content .video-overlay");

			btns.classList.add("hidden");
			overlay.classList.add("hidden");

			// pause slide playback
			playback = false;

			// Play video once only... 
			// set var to hide featured slide after playback completes
			hasfeatured = false;

			// init video scale 
			setVideoScale();
			window.addEventListener("resize", setVideoScale);

			// remove first backgrond image as first element is video bg
			bg.shift();

			// shuffle BG Img array
			let shuffled = bg.reduce((a,c,i,r,j)=>(j=Math.random()*(a.length-i)|0,[a[i],a[j]]=[a[j],a[i]],a),[...bg]);

			bg = shuffled;

			// setup playback events
			player.on('play', function() {
				let overlays = document.querySelector(".variable-bg-block").querySelectorAll(".variable-bg-block .video-overlay");
				const overlaysTotal = overlays.length;

				playbtn.remove();
				
				if (overlays) {
					player.getDuration().then(function(duration) {
						// duration = the duration of the video in seconds
						videoDuration = duration;
						//console.log('video - start: ', videoDuration);

						if (videoDuration >= 15) {
							delayTime = 3; // 2sec
							let sequenceTime = (videoDuration - (delayTime * 2)) / overlaysTotal;

							// convert to ms
							sequenceTime = Math.round(sequenceTime * 1000); 
							delayTime = delayTime * 1000;

							// init animations
							initOverlayAnimation(overlays,sequenceTime,delayTime);
						}

					}).catch(function(error) {
						// an error occurred
					});
				}
	
			});

			player.ready().then(function() {
				// the player is ready
				player.setMuted(true);
				

				$(el).on("click", function (e) {
					if (player) {
						player.play();
						playbtn.remove();
					}
				});

				//console.log('VIDEO READY');
			});


			player.on('timeupdate', function() {
				
				player.getCurrentTime().then(function(seconds) {
					// seconds = the current playback position
					currentTime = seconds;
				}).catch(function(error) {
					// an error occurred
				});


			});

			player.on('ended', function() {
				//console.log('video - end playback');

				// start slide playback
				playback = true;

				// remove event listener
				window.removeEventListener("resize", setVideoScale);

				// remove video element and wrapper
				player.destroy();
				$(el).removeClass("has-featured-video");

				// show standard container
				let standard = document.querySelector(".variable-bg-block .default_content"); 
				standard.classList.add("show");

				// hide featured container
				let featured = document.querySelector(".variable-bg-block .featured_content"); 
				featured.classList.add("hidden");

				// swap bg image
				var newBg = bg[0];
				block.css('background-image', `url(${newBg})`);

				// init transitions and start playback
				startTransition(block, bg, hasfeatured, playback, hasfeaturedVideo);
			});
		}

		// preload images
		for( let i = 0; i < bg.length; i++ ) {
			let img = new Image();
			img.src = bg[i];

			// check load
			img.onload = () => {
				loaded++;
				if( loaded == bg.length ) {
					startTransition(block, bg, hasfeatured, playback, hasfeaturedVideo);
				}
			}
		}

	});
}

function startTransition(block, backgrounds, hasfeatured, playback, hasfeaturedVideo) {
	// change background every 6 seconds
	var bgIndex = 0;
	var timer = 6000;

	if (playback) {
		setInterval(() => {
			var index = (++bgIndex % backgrounds.length);
			let newBg = backgrounds[index];

			// toggle visibility
			if (hasfeatured || hasfeaturedVideo) {
				setFeatured(hasfeatured,index);
			}

			//block.css('background-color', 'rgba(0,0,0,0.9)');
			//block.css('transition', '0.25s');

			block.css('background-image', `url(${newBg})`);

			/*
			setTimeout(() => {
				block.css('background-color', 'rgba(0,0,0,0.15)');
				block.css('transition', '1s');
			  }, "250");
			  */
			  

		}, timer);
	}
}

function setFeatured(hasfeatured, index) {
	let standard = document.querySelector(".variable-bg-block .default_content"); 
	let featured = document.querySelector(".variable-bg-block .featured_content");

	if (!hasfeatured || standard == null || featured == null) {
		return;
	}

	if (index == 0 && hasfeatured) { // show featured content for first slide 
		standard.classList.remove('show');
		standard.classList.add('hidden');

		featured.classList.remove("hidden");
		featured.classList.add("show");
		
	} else { // show default content
		standard.classList.add("show");
		standard.classList.remove("hidden");

		featured.classList.add("hidden");
		featured.classList.remove("show");
	}
}

// scales video within container element to fill background. 
// use width for landscape orientation, height for portrait
function setVideoScale() {
	
	document.querySelectorAll('.has-featured-video').forEach(container => {
		const video = container.querySelector('iframe');

		// Adjust scale if element is present 
		if (video){
			const videoAspectRatio = video.clientWidth / video.clientHeight;

			//console.log(video.clientWidth,video.clientHeight);
			//console.log(container.clientWidth,container.clientHeight);

			video.style.height = `${container.clientHeight}px`;
			video.style.width = `${container.clientWidth * videoAspectRatio}px`;

			if (container.clientHeight > container.clientWidth) {
				video.style.width = `${container.clientHeight * videoAspectRatio}px`;
			}
		}
	  
	})

}

function initOverlayAnimation(overlays,sequenceTime,delayTime) {

	let delay = delayTime;
	let length = overlays.length;
	let btns = document.getElementById("feature-buttons");

	overlays.forEach(function (item, index, el) {
		//console.log(item,index,el);

		// set delayTime, increment for each element
		delay = delayTime + (sequenceTime * index);

		//console.log('delay:' , delay);

		setTimeout(() => {
			item.classList.remove('hidden');

			//item.classList.add('show');
			if (index == 0) {
				btns.classList.remove("hidden");

				// add transitions
				item.classList.add("fadeIn");
				btns.classList.add("fadeIn");
			}
			// get preceding sibling
			let prevElem = item.previousElementSibling;

			// hide sibling
			if (prevElem != null && prevElem.matches(".video-overlay")) {
				prevElem.classList.add("hidden");
			}

		}, delay);

		// last item so add out transition
		if ( (index + 1) == length && length > 1) {

			setTimeout(() => {
				btns.classList.remove("fadeIn");
				item.classList.add("fadeOut");
				btns.classList.add("fadeOut");

				//item.style.opacity = "0";
				//btns.style.opacity = "0";

			}, ( delay + sequenceTime + (delayTime/4)) );
		}

	});

	
}